import React from 'react';
import { Form, Button, Row, Col } from 'react-bootstrap';
import { UserProfile } from '../../models/UserProfile';
import { UserProfileUIStore } from '../../stores/user-profile-ui-store';
import { LogoUpload } from '../logo/logo-upload';

interface SettingsPageProps {
  userProfile: UserProfile;
  userProfileUIStore?: UserProfileUIStore;
  onLogoUploaded: (logoUrl: string) => void;
  onLogoRemoved: () => void;
  onPreparedByChange: (value: string) => void;
  onSaveSettings: () => void;
  onError: (error: string) => void;
}

export const SettingsPage: React.FC<SettingsPageProps> = ({
  userProfile,
  userProfileUIStore,
  onLogoUploaded,
  onLogoRemoved,
  onPreparedByChange,
  onSaveSettings,
  onError,
}) => {
  const [preparedBy, setPreparedBy] = React.useState(
    userProfile.preparedBy || '',
  );

  const handlePreparedByChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const val = e.target.value;
    if (val.length > 32) {
      return;
    }
    setPreparedBy(val);
    onPreparedByChange(val);
  };

  return (
    <div>
      <h4>General Settings</h4>
      <hr />

      <Form className="mb-5">
        <Form.Group as={Row} controlId="formPreparedBy">
          <Form.Label column sm={3}>
            Prepared By
          </Form.Label>
          <Col sm={9}>
            <Form.Control
              type="text"
              style={{ width: '240px' }}
              placeholder="e.g. MaryAnn Marks"
              value={preparedBy}
              onChange={handlePreparedByChange}
            />
            <Form.Text className="text-muted">
              When you enter a name in this field, it will appear as "Prepared
              by: NAME" on the cover page and footer of both PDF reports.
              <br />
              If you choose not to include a "Prepared by: NAME" on the reports,
              leave this field blank.
            </Form.Text>
          </Col>
        </Form.Group>

        <Form.Group as={Row}>
          <Col sm={{ span: 9, offset: 3 }}>
            <Button variant="primary" onClick={onSaveSettings}>
              Save Settings
            </Button>
          </Col>
        </Form.Group>
      </Form>

      <h4>Custom Logo</h4>
      <p className="text-muted">
        Manage the logo that appears on your reports.
      </p>
      <hr />

      <LogoUpload
        userProfile={userProfile}
        userProfileUIStore={userProfileUIStore}
        onLogoUploaded={onLogoUploaded}
        onLogoRemoved={onLogoRemoved}
        onError={onError}
      />
    </div>
  );
};
